import React from "react";
import moment from "moment";
import { Badge } from "./Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { INotification } from "api/rpc/2024-04/customer/teesheet";

interface IConnectedBadgeProps {
    notification: INotification;
    formattedDate: string;
    isMobile: boolean;
    onClick: (e: React.MouseEvent) => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    isActive: boolean;
    isHovered: boolean;
    showText?: boolean;
}

export const ConnectedBadge: React.FC<IConnectedBadgeProps> = ({
    notification,
    formattedDate,
    isMobile,
    onClick,
    onMouseEnter,
    onMouseLeave,
    isActive,
    isHovered,
    showText = true,
}) => {
    const current = moment(formattedDate).startOf("day");
    const start = moment(notification.start_date).startOf("day");
    const end = moment(notification.end_date).startOf("day");

    const isFirst = current.isSame(start);
    const isLast = current.isSame(end);

    const connectedLeft = !isFirst;
    const connectedRight = !isLast;

    return (
        <div
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className="connection-badge-wrapper"
        >
            <Badge
                className={`status-badge event connection-badge${isActive ? " active" : ""}${isHovered ? " is-hovered" : ""}${connectedLeft ? " connected-left" : ""
                    }${connectedRight ? " connected-right" : ""}`}
                size="small"
                onClick={onClick}
            >
                {isMobile ? (
                    showText && <FontAwesomeIcon icon={faCircleInfo} />
                ) : (
                    showText && <span className="notification-subject">{notification.subject}</span>
                )}
            </Badge>
        </div>
    );
};
